import { useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TRACK_SESSION_KEY = "__dj_tracked";

export const VisitTracker = () => {
  useEffect(() => {
    // Don't track admin pages or duplicates in same session for current path
    if (window.location.pathname.startsWith("/admin")) return;
    const key = `${TRACK_SESSION_KEY}:${window.location.pathname}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");

    const payload = {
      path: window.location.pathname + window.location.hash,
      referrer: document.referrer || null,
      user_agent: navigator.userAgent,
      language: (navigator.language || "").slice(0, 20),
      screen: `${window.innerWidth}x${window.innerHeight}`,
    };
    axios.post(`${API}/track`, payload).catch(() => {});
  }, []);

  return null;
};
